import React from "react";
import ContactForm from "./ContactForm"; // Adjust path if necessary
import { Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

const ContactPage = () => {
  return (
    <>
      <Helmet>
        <title>Contact FlyBnB | Get in Touch</title>
        <meta name="description" content="Have a question or feedback? Contact the FlyBnB team — we'd love to hear from you." />
        <meta property="og:title" content="Contact FlyBnB" />
        <meta property="og:description" content="Have a question or feedback? Contact the FlyBnB team." />
        <link rel="canonical" href="https://flybnb.io/contact" />
      </Helmet>
      <Box
        sx={{
          px: { xs: 3, sm: 4, md: 6 },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        <ContactForm />
      </Box>
    </>
  );
};

export default ContactPage;
